import { View as RNView } from "react-native";
import {
  withLayoutPropsV2,
  type WithLayoutPropsV2,
} from "~/hoc/withLayoutPropsV2";
import type React from "react";
import type { ViewProps as RNViewProps } from "react-native";

export const View = withLayoutPropsV2(RNView);
export type View = React.ElementRef<typeof RNView>;
export type ViewProps = Omit<RNViewProps, keyof WithLayoutPropsV2> &
  WithLayoutPropsV2;
